uniform float uTime;
uniform float uPixelRatio;
uniform float uSize;

attribute float aScale;
attribute vec3 aSpeed;

void main()
{
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectionPosition = projectionMatrix * viewPosition;

    gl_Position = projectionPosition;

    // Size
    gl_PointSize = uSize * aScale * uPixelRatio;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Fade based on time
    float fade = sin(uTime * 2.0 + aSpeed.x * 100.0) * 0.5 + 0.5;
    gl_PointSize *= fade;
} 